import { mapState } from 'vuex'
import cookie from 'js-cookie'
import {
  reqCyQueryAdvert, reqCyGetPoints
} from 'changyo-public-api'
import requestApi from 'changyo-public-api/src/libs/requestApi'
import ajaxUtil from 'cy_static/ajaxUtil'
import GoodsCard from '../../components/GoodsCard'
import ModelPointsDesc from '@/components/ModelPointsDesc'
import ModelPointsSoon from '@/components/ModelPointsSoon'
import getCurrentUrl from '@/assets/libs/getCurrentUrl'
import util from '@/assets/libs/util'
import Banner from './components/jfSwiper'
import WaterfallTabHJF from '@/components/WaterfallTabHJF1'
import HjfNotice from '@/components/hjfNotice'
import getBrowser from './getBrowser'
import BallBlock from './components/BallBlock'
import YBK from './components/YBK'
import FooterTab from "@/components/FooterTab"
import memberService from '@/service/memberService';
let cytoken=spm.getQueryValue('cytoken')
export default {
  name: 'hjf',
  computed: {
    ...mapState([
      'appid',
    ])
  },
  components: {
    YBK,
    BallBlock,
    GoodsCard,
    ModelPointsDesc,
    ModelPointsSoon,
    Banner,
    WaterfallTabHJF,
    HjfNotice,
    FooterTab,
  },

  data() {
    return {
      bannerInfo: {},
      displayBallBlock: true,
      leftList: [],
      rightList: [],
      banner2: [],
      pageIndex: 1,
      pageSize: 10,
      banner2items:[],
      finished: false,
      empty: false,
      displayModelPointsDesc: false,
      displayModelPointsSoon: false,
      userPointsInfo: {},
      recomsData: [],
      dredge: true,
      isVip: false,
      getPoint: false,
      isToken:/^1\d{10}$/.test(window.atob(spm.getQueryValue('token'))||sessionStorage.getItem('coffeeflag')),
      mobile:''
      // isVip: false
    }
  },
  created() {
    if(cytoken){
      console.log(cytoken,window.atob(cytoken))
      spm.util.cookie.set('login_token',window.atob(cytoken))
    }
    this.initbanner2items();
    const browserUtil = getBrowser()
    spm.setPageCode('102554', {
      title: "畅由积分当钱花",
      pageName: "积分管家首页",
      dept: "产品"
    });
    gio('page.set', {
      'platform_pvar': browserUtil.jfmore ? (browserUtil.ios ? 'ios' : 'android') : 'web'
    })
    spm.push(['_trackPageview']);
  },
  mounted() {
    cyPopLogin.check(status => {
      let mobile=window.atob(spm.getQueryValue('token'))
      if(/^1\d{10}$/.test(mobile)){
        sessionStorage.setItem('coffeeflag',mobile)
      }
      if (status === 0) {
        if(this.isToken){
          cyPopLogin.setMobile(mobile,0)
        }
        cyPopLogin.show()
        cyPopLogin.success = () => {
          // alert("this.init")
          // this.init()
          window.location.reload();
        }
      } else {
        this.init()
        let self=this
            // 先查询用户信息
        memberService.accountSet({
          method: "POST",
          body: {
            login_token: cookie.get('login_token')
          }
        }).then(function (data) {
          console.log('data',data)
          self.mobile=data.mobileNo
        });
      }
    })
  },

  methods: {
    init() {
      this.getPoints()
      // this.getBanner()
      // this.getBanner2()
      // this.getList()
      // this.getAllBindInfo()
      this.getRecomsData()
      this.getVipState()
    },
    async getVipState() {
      ajaxUtil.loadData('/vipclub/vip/queryUserVipState', {
        method: 'POST',
        standard: 'standard',
        body: {
          login_token: cookie.get('login_token'),
          vipCode: 'changyoVip',
          platform: 'h5'
        }
      }).then(res => {
        this.isVip = res.data.isVip
      })
    },
    loadUrl: function(url) {
			console.log('--loadNativeUrl--');
			console.log(url);
			var f = document.createElement("iframe");
			f.setAttribute("src", url);
			f.setAttribute("style", "display:none;");
			f.setAttribute("height", "0");
			f.setAttribute("width", "0");
			f.setAttribute("frameborder", "0");
			document.body.appendChild(f);
			//发起请求后这个iframe就没用了，所以把它从dom上移除掉
			f.parentNode.removeChild(f);
			f = null;
		},
    toUrl(){
      location.href='https://changyou.cocafe.co/?token='+btoa(this.mobile);
    },
    goNext() {
      const browserUtil = getBrowser()
      const type = browserUtil.jfmore ? 'jfmore_h5' : browserUtil.weixin ? 'weixin_h5' : 'h5'
      if (this.isVip) {
        if(type === 'jfmore_h5'){
          var url = 'native://user?action=toMall';
          this.loadUrl(url)
        } else {
          location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.centchain.changyo&amp;from=singlemessage&amp;isappinstalled=0'
        }
      } else {
        if(this.userPointsInfo.points < 990) {
          const anchorEle = document.querySelector("#getPoint");
          if (!!anchorEle ) {
            anchorEle .scrollIntoView(true);
          }
        } else {
          location.href ="/vip/index.html#/order?channelSource=" + spm.getSource() + '&activityCode=' + spm.util.getQueryValue('activityCode') + '&channelSourceName=' + spm.util.getQueryValue('channelSourceName')
        }
      }
    },

    // async getBanner() {
    //   const param = {
    //     appId: 'Changyoyo_Life_Central',
    //     featuredFirstCode: 'H5_110_goods3',
    //     channel: 'Changyoyo_Life_Central',
    //     pageNum: 1,
    //     pageSize: 10
    //   }

    //   const res = await reqCyQueryAdvert(param).catch(err => console.log(err))

    //   if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
    //     this.bannerInfo = res.data.advertiseOnlines[0]
    //   }
    // },
    goPointsDetail() {
      this.$router.push({name:'points-detail', query:{index:"2"}})
    },
    async getRecomsData() {
      const param = {
        appId: 'Changyoyo_Life_Central',
        featuredFirstCode: 'H5_jfpd_gnq',
        channel: 'Changyoyo_Life_Central',
        pageNum: 1,
        pageSize: 10
      }
      const res = await reqCyQueryAdvert(param).catch(err => console.log(err))

      if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
        this.recomsData = res.data.advertiseOnlines
      }
    },

    async getPoints() {
      const res = await reqCyGetPoints({ login_token: cookie.get('login_token') }).catch(err => console.log(err))

      if (res && res.data) {
        this.userPointsInfo = res.data
      }
    },

    // async getBanner2() {
    //   const param = {
    //     appId: 'Changyoyo_Life_Central',
    //     featuredFirstCode: 'H5_110_goods2',
    //     channel: 'Changyoyo_Life_Central'
    //   }

    //   const res = await reqCyQueryAdvert(param).catch(err => console.log(err))

    //   if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
    //     this.banner2 = res.data.advertiseOnlines
    //   }
    // },

    // async getList() {
    //   const param = {
    //     appId: 'Changyoyo_Life_Central',
    //     featuredFirstCode: 'H5_110_goods',
    //     channel: 'Changyoyo_Life_Central',
    //     pageNum: this.pageIndex,
    //     pageSize: this.pageSize
    //   }

    //   const res = await reqCyQueryRights(param).catch(err => console.log(err))

    //   if (res && res.data && res.data.spuCodes && res.data.spuCodes.length > 0) {

    //     if (res.data.spuCodes.length < this.pageSize) {
    //       this.finished = true
    //     }

    //     if (res.data.spuCodes.length === 0 && this.pageNum === 1) {
    //       this.empty = true
    //     }

    //     const spuInfo = await reqCyQuerySpuBySpuCodes({
    //       channel: 'Changyoyo_Life_Central',
    //       spuCodes: res.data.spuCodes.join(',')
    //     }).catch(err => console.log(spuInfo))

    //     if (spuInfo && spuInfo.data && spuInfo.data.spuList && spuInfo.data.spuList.length > 0) {

    //       // 划分左右瀑布流
    //       for (let i = 0; i < spuInfo.data.spuList.length; i++) {
    //         if (i % 2 === 0) {
    //           this.leftList = this.leftList.concat(spuInfo.data.spuList[i])
    //         } else {
    //           this.rightList = this.rightList.concat(spuInfo.data.spuList[i])
    //         }
    //       }
    //     }
    //   } else {
    //     this.empty = true
    //   }
    // },

    // async getAllBindInfo() {
    //   const param = { login_token: cookie.get('login_token') }
    //   const info = await Promise.all([
    //     reqCyButlerAllBindInfo(param).catch(err => console.log(err)),
    //     // reqCyButlerBindingCMCC(param).catch(err => console.log(err)),
    //     // reqCyButlerBindingBoc(param).catch(err => console.log(err)),
    //     // reqCyButlerBindingCeair(param).catch(err => console.log(err)),
    //     // reqCyButlerActiveCMCC(param).catch(err => console.log(err))
    //   ])

    //   const bindInfo = info[0]
    //   // const cmccInfo = info[1]
    //   // const bocInfo = info[2]
    //   // const ceair = info[3]
    //   // const cmccActiveInfo = info[4]

    //   // 设置绑定移动链接
    //   // if (cmccInfo && cmccInfo.data && cmccInfo.data.mobileurl) {
    //   //   this.section2Data[0].typeData[0].link = cmccInfo.data.mobileurl
    //   // }

    //   // 设置移动激活链接
    //   // if (cmccActiveInfo && cmccActiveInfo.data && cmccActiveInfo.data.mobileurl) {
    //   //   this.section2Data[0].typeData[2].link = cmccActiveInfo.data.mobileurl
    //   // }

    //   // 设置绑定中行链接
    //   // if (bocInfo && bocInfo.data && bocInfo.data.bindingurl) {
    //   //   this.section2Data[1].typeData[0].link = bocInfo.data.bindingurl
    //   // }

    //   // 设置绑定东航链接
    //   // if (ceair && ceair.data && ceair.data.bindingurl) {
    //   //   this.section2Data[2].typeData[0].link = ceair.data.bindingurl
    //   // }

    //   // 设置绑定信息
    //   if (bindInfo) {

    //     // 设置中行信息
    //     if (!bindInfo.data.boc) {
    //       this.section2Data[1].type = 0
    //     } else {
    //       if (bindInfo.data.boc.code === '6666') {
    //         this.section2Data[1].type = 3
    //       } else {
    //         if (bindInfo.data.boc.bindStatus === 1) {
    //           this.section2Data[1].type = 1
    //           this.section2Data[1].typeData[1].points = Math.min(
    //             Math.floor(bindInfo.data.boc.lmPoints / bindInfo.data.boc.rate),
    //             bindInfo.data.boc.day_points_num,
    //             // bindInfo.data.boc.max_trace_points,
    //             bindInfo.data.boc.month_points_num
    //           )
    //         }
    //       }
    //     }

    //     // 设置东航信息
    //     if (!bindInfo.data.ceair) {
    //       this.section2Data[2].type = 0
    //     } else {
    //       if (bindInfo.data.ceair.code === '6666') {
    //         this.section2Data[2].type = 3
    //       } else {
    //         if (bindInfo.data.ceair.bindStatus === 1) {
    //           this.section2Data[2].type = 1
    //           this.section2Data[2].typeData[1].points = Math.min(
    //             Math.floor(bindInfo.data.ceair.lmPoints * bindInfo.data.ceair.rate),
    //             bindInfo.data.ceair.day_points_num,
    //             // bindInfo.data.ceair.max_trace_points,
    //             bindInfo.data.ceair.month_points_num
    //           )
    //         }
    //       }
    //     }

    //     // 设置移动信息
    //     if (!bindInfo.data.cmcc) {
    //       this.section2Data[0].type = 0
    //     } else {
    //       if (bindInfo.data.cmcc.code === '6666') {
    //         this.section2Data[0].type = 3
    //       } else {
    //         if (bindInfo.data.cmcc.bindStatus === 1) {
    //           this.section2Data[0].type = 1
    //           this.section2Data[0].typeData[1].points = Math.min(
    //             Math.floor(bindInfo.data.cmcc.lmPoints / bindInfo.data.cmcc.rate),
    //             bindInfo.data.cmcc.day_points_num,
    //             // bindInfo.data.cmcc.max_trace_points,
    //             bindInfo.data.cmcc.month_points_num
    //           )
    //         }

    //         // 冻结，需要去激活
    //         if (bindInfo.data.cmcc.bindStatus === 2) {
    //           this.section2Data[0].type = 2
    //         }
    //       }
    //     }
    //   }

    //   // 更新数据状态
    //   this.section2Data = [ ...this.section2Data ]
    // },

    async getShortLink() {
      const api = '/pgate/pointgate/activity/api/mall/realUrl'
      const params = {
        login_token: cookie.get('login_token'),
        url: getCurrentUrl() + '#/hjf'
      }
      const opt = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const res = await requestApi(api, params, opt).catch(err => util.toast(err.retMsg))

      if (res) {
      }
    },

    formatPoints(points) {
      const reg = /\d{1,3}(?=(\d{3})+$)/g

      return points.toString().replace(reg, '$&,')
    },

    toBannerLink(bannerInfo) {
      location.href = bannerInfo.jumpLink
    },

    handlePageScroll(e) {
      this.$refs.dzq.getScroll(e)
      // if (!this.finished) {
      //   if (this.timer) {
      //     clearTimeout(this.timer)
      //   }

      //   this.timer = setTimeout(() => {
      //     const target = e.target
      //     const winHeight = window.innerHeight
      //     const scrollTop = target.scrollTop
      //     const scrollHeight = target.scrollHeight

      //     if (winHeight + scrollTop >= scrollHeight - 10) {
      //       this.pageIndex++
      //       this.getList()
      //     }
      //   }, 500)
      // }
    },

    async initbanner2items() {
      const res = await reqCyQueryAdvert({
        featuredFirstCode: "H5_new_HomeEntry",
        channel: "Changyoyo_Life_Central"
      }).catch(err => {
        console.log(err)
      })

      if (res && res.data) {
        const list = res.data.advertiseOnlines

        if (list.length) {
          // this.banner2items = this.groupList(list,10)
          this.banner2items = list
          // console.log("this.banner2items")
          // console.log(this.banner2items)
        }
      }
    },
    toPointDetail() {
      this.$router.push('/points-detail')
    },
    toPointStrategy() {
      this.$router.push('/hjfStrategy')
    },
    toBallItem(item) {
      location.href = item.jumpLink
    },

    // section2ItemBtnClick(url) {
    //   cookie.set('jumpBack', getCurrentUrl() + '#/hjf')
    //   cookie.set('flag', 1)

    //   setTimeout(() => {
    //     location.href = url
    //   }, 500)
    // },

    toExpiredPoints() {
      this.$router.push('/expired-points')
    },

    onModelPointDescSubmit() {
      this.displayModelPointsDesc = false
    },

    onModelPointSoonSubmit() {
      this.displayModelPointsSoon = false
    },

    // linkTo(link) {
    //   location.href = link
    // },

    // toSpuUrl(spu) {
    //   if (spu.spuUrl && spu.spuUrl !== '1') {
    //     location.href = spu.spuUrl
    //   } else {
    //     location.href = '/mall2/cy/goodsDetail/index.html?spuCode=' + spu.spuCode + '&appId=Changyoyo_Life_Central'
    //   }
    // },

    // async toBindLink(type, item) {
    //   const param = {
    //     login_token: cookie.get('login_token'),
    //     callback: getCurrentUrl(),
    //     failUrl: getCurrentUrl()
    //   }

    //   cookie.set('jumpBack', getCurrentUrl() + '#/hjf')
    //   cookie.set('flag', 1)

    //   if (type === 'mobile') {
    //     const res = await reqCyButlerBindingCMCC(param).catch(err => console.log(err))

    //     if (res && res.data) {
    //       if (res.data.mobileurl) {
    //         setTimeout(() => {
    //           location.href = res.data.mobileurl
    //         }, 500)
    //       } else {
    //         util.toast(res.data.msg)
    //       }
    //     }

    //   } else if (type === 'air') {
    //     const res = await reqCyButlerBindingCeair(param).catch(err => console.log(err))

    //     if (res && res.data) {
    //       if (res.data.bindingurl) {
    //         location.href = res.data.bindingurl
    //       } else {
    //         util.toast(res.data.msg)
    //       }
    //     }
    //   } else if (type === 'boc') {
    //     const res = await reqCyButlerBindingBoc(param).catch(err => console.log(err))

    //     if (res && res.data) {
    //       if (res.data.bindingurl) {
    //         location.href = res.data.bindingurl
    //       } else {
    //         util.toast(res.data.msg)
    //       }
    //     }
    //   } else {
    //     location.href = item.link
    //   }
    // },

    // async toActiveLink(type) {
    //   const param = {
    //     login_token: cookie.get('login_token'),
    //     callback: getCurrentUrl(),
    //     failUrl: getCurrentUrl()
    //   }

    //   if (type === 'mobile') {
    //     cookie.set('jumpBack', getCurrentUrl() + '#/hjf')
    //     cookie.set('flag', 1)

    //     const res = await reqCyButlerActiveCMCC(param).catch(err => console.log(err))

    //     if (res) {
    //       setTimeout(() => {
    //         location.href = res.data.mobileurl
    //       }, 500)
    //     }
    //   }
    // }
  }
}
